import { Injectable, inject } from '@angular/core';
import {
  ArriveFreightStopCommand,
  ArriveFreightStopCommandHandler,
  DepartFreightStopCommand,
  DepartFreightStopCommandHandler,
  RequestPayInAdvanceCommand,
  RequestPayInAdvanceCommandHandler,
  UpdateFreightDriverAndVehiclesAsCarrierCommand,
  UpdateFreightDriverAndVehiclesAsCarrierCommandHandler,
  UploadFreightDocumentCommand,
  UploadFreightDocumentCommandHandler,
  VerifyFreightStopGoodsInfoCommand,
  VerifyFreightStopGoodsInfoCommandHandler,
} from '@okcargo/command-processor';
import { BaseCommandRepository } from '../command-repository/command.repository';

@Injectable({ providedIn: 'root' })
export class FreightCarrierCommandService {
  private readonly updateFreightDriverAndVehiclesAsCarrierCommandHandler: UpdateFreightDriverAndVehiclesAsCarrierCommandHandler;
  private readonly arriveFreightStopCommandHandler: ArriveFreightStopCommandHandler;
  private readonly departFreightStopCommandHandler: DepartFreightStopCommandHandler;
  private readonly verifyFreightStopGoodsInfoCommandHandler: VerifyFreightStopGoodsInfoCommandHandler;
  private readonly uploadFreightDocumentCommandHandler: UploadFreightDocumentCommandHandler;
  private readonly requestPayInAdvanceCommandHandler: RequestPayInAdvanceCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.updateFreightDriverAndVehiclesAsCarrierCommandHandler =
      new UpdateFreightDriverAndVehiclesAsCarrierCommandHandler(commandRepository);
    this.arriveFreightStopCommandHandler = new ArriveFreightStopCommandHandler(commandRepository);
    this.departFreightStopCommandHandler = new DepartFreightStopCommandHandler(commandRepository);
    this.verifyFreightStopGoodsInfoCommandHandler = new VerifyFreightStopGoodsInfoCommandHandler(commandRepository);
    this.uploadFreightDocumentCommandHandler = new UploadFreightDocumentCommandHandler(commandRepository);

    // TODO move to another service (fast-payment)
    this.requestPayInAdvanceCommandHandler = new RequestPayInAdvanceCommandHandler(commandRepository);
  }

  public updateFreightDriverAndVehiclesAsCarrier(
    command: UpdateFreightDriverAndVehiclesAsCarrierCommand,
  ): Promise<void> {
    return this.updateFreightDriverAndVehiclesAsCarrierCommandHandler.handle(command);
  }

  public arriveToFreightStop(command: ArriveFreightStopCommand): Promise<void> {
    return this.arriveFreightStopCommandHandler.handle(command);
  }

  public departFromFreightStop(command: DepartFreightStopCommand): Promise<void> {
    return this.departFreightStopCommandHandler.handle(command);
  }

  public verifyFreightStopGoodsInfo(command: VerifyFreightStopGoodsInfoCommand): Promise<void> {
    return this.verifyFreightStopGoodsInfoCommandHandler.handle(command);
  }

  public uploadFreightDocument(command: UploadFreightDocumentCommand): Promise<void> {
    return this.uploadFreightDocumentCommandHandler.handle(command);
  }

  // TODO move to another service (fast-payment)
  public requestPayInAdvance(command: RequestPayInAdvanceCommand): Promise<void> {
    return this.requestPayInAdvanceCommandHandler.handle(command);
  }
}
